import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import {
  BenchmarkType,
  PlotReportFactElement,
  PlotReportFactLabelNameEnum,
  SpeciesEnum,
} from '@/api/rest/resources/types/fact';
import { GraphFact } from '@/components/Charts/types';
import { BenchmarkPill } from '@/components/Pill/BenchmarkPill';
import { isNullish } from '@/utils/booleans';

export type SpeciesGradientStatsTileProps = {
  meadowsBenchmarkFact: PlotReportFactElement<GraphFact[] | null> | undefined;
  meadowsBenchmarkTextFact: PlotReportFactElement<string | null> | undefined;
  species: SpeciesEnum;
};

export const SpeciesGradientStatsTile = ({
  meadowsBenchmarkFact,
  meadowsBenchmarkTextFact,
  species,
}: SpeciesGradientStatsTileProps) => {
  const { t } = useTranslation();

  const benchmarkType = meadowsBenchmarkFact?.value
    ?.find((f) => f.labels?.some((l) => l.name === PlotReportFactLabelNameEnum.species && l.value === species))
    ?.labels?.find((l) => l.name === PlotReportFactLabelNameEnum.benchmark)?.value as BenchmarkType | undefined;

  if (isNullish(benchmarkType) || isNullish(meadowsBenchmarkTextFact?.value)) {
    return null;
  }

  return (
    <Stack className='justify-center gap-8 p-6 lg:gap-4 lg:p-8 lg:pr-2' data-testid='species-gradient-stats-tile'>
      <div className='flex flex-col gap-8 lg:gap-4'>
        <Stack direction='row' className='flex-wrap gap-6'>
          {benchmarkType && (
            <Stack className='mt-4 gap-4 rounded-2xl bg-neutral-black-4 px-4 py-6'>
              <BenchmarkPill benchmarkType={benchmarkType} />
              <span className='typography-body1Bold'>
                {t('shared.ncaDetail.details.speciesGradient.labels.whatDoesThisMean')}
              </span>
              <p className='typography-body1 text-text-secondary'>{meadowsBenchmarkTextFact?.value}</p>
            </Stack>
          )}
        </Stack>
      </div>
    </Stack>
  );
};
